import { IRespuesta } from '@infotrack/presentacion-transversales/interfacesComunes';
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';
import { negocio } from '../../conexiones';
import IItemImagenAccion from './entidades/itemImagenAccion';
export default class ModeloItemImagenes {
    public consultarItemImagenes(ItemId: number) {
        return manejadorRest<IRespuesta<IItemImagenAccion>>(
            () => negocio.post('ItemImagen/ConsultarItemImagenCompuestaFiltro', { ItemId }),
            true
        );
    }
}
